<template>
    <tr :class="row.roles.includes('ROLE_ADMIN') ? 'danger' : 'info'">
        <td class="user-avatar cell-detail user-info">
            <avatar class="mt-0 mt-md-2 mt-lg-0" :username="`${row.firstname} ${row.lastname}`" :src="row.avatarSmall" :size="30"/>
            <span>{{row.firstname}} {{row.lastname}}</span>
            <span class="cell-detail-description">{{row.email}}</span>
        </td>
        <td class="cell-detail">
            <span v-if="row.archived">Archiviert</span>
            <span v-else>Aktiv</span>
            <span class="cell-detail-description">Erstellt: {{row.longCreatedAt}}</span>
            <span class="cell-detail-description" v-if="row.longLastLogin">Letzte Anmeldung: {{row.longLastLogin}}</span>
        </td>
        <td class="cell-detail">
            <user-roles :user="row" :is-current="row.id === profile.id"/>
        </td>
        <td class="text-right">
            <div class="btn-group" v-if="row.id !== profile.id">
                <router-link class="btn btn-secondary" title="Bearbeiten" :to="{ name: 'edit-user', params: { id: row.id } }"><i class="icon mdi mdi-edit"></i></router-link>
                <router-link class="btn btn-secondary" title="Passwort ändern" :to="{ name: 'admin-user-password', params: { id: row.id } }"><i class="icon mdi mdi-key"></i></router-link>
                <button class="btn btn-secondary" :title="`Anmelden als ${row.firstname} ${row.lastname}`" @click="switchUser"><i class="icon mdi mdi-sign-in"></i></button>

                <button class="btn btn-warning" title="Wiederherstellen" @click="restoreUser" v-if="row.archived"><i class="icon mdi mdi-time-restore"></i></button>
                <button class="btn btn-warning" title="Archivieren" @click="archiveUser" v-else><i class="icon mdi mdi-delete"></i></button>
            </div>
        </td>
    </tr>
</template>

<script>
    import { mapState } from 'vuex';
    import errorHandler from '../../../../mixins/errorHandler';
    import User from '../../../../models/User';
    import UserRoles from './_Roles';

    export default {
        mixins: [errorHandler],
        components: { UserRoles },

        props: {
            row: {
                type: User,
                required: true,
            },
        },

        computed: {
            ...mapState('user', ['profile']),

            userRoles: () => user => user.roles.filter(role => !!User.RolesMap[role]).map(
                role => User.RolesMap[role],
            ),
        },

        methods: {
            async switchUser() {
                this.$store.dispatch('user/switchUser', this.row.email);
                this.$router.push({ name: 'home' });
            },

            async archiveUser() {
                try {
                    this.$emit('update', this.row.id, { archived: true });
                } catch (err) {
                    this.catchError('Archivieren fehlgeschlagen', 'Der Benutzer konnte nicht archiviert werden.', err);
                }
            },

            async restoreUser() {
                try {
                    this.$emit('update', this.row.id, { archived: false });
                } catch (err) {
                    this.catchError('Wiederherstellen fehlgeschlagen', 'Der Benutzer konnte nicht wiederhergestellt werden.', err);
                }
            },
        },
    };
</script>

<style lang="scss">
    td.user-avatar .vue-avatar {
        float: left;
        margin-right: 10px;

        > span {
            padding: 0 !important;
        }
    }
</style>
